module.exports = __webpack_public_path__ + "img/pay_img.fb82e40f.png";